import { z } from 'zod'

/**
 * A free-text URL parameter. A blank value is a no-op the URL should not carry,
 * so the schema trims the value and then drops it when nothing is left. A shared
 * link then says exactly what it filters by.
 *
 * The cap applies AFTER the trim. A form that validates the trimmed value would
 * otherwise see a link to a legitimately saved value dropped only because of the
 * spaces around it.
 */
export const trimmedTextParam = (maxLength: number) =>
  z
    .string()
    .transform((value) => value.trim())
    .pipe(z.string().min(1).max(maxLength))
    .optional()
    .catch(undefined)
